<template>
<div class="pmtdiv">
    <linkbutton toplabel="Update Prep Areas" @click="Show()"  />

    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                
                <label class="titlelabel">{{name}}</label>
                <br/>
                
                <optionbuttonmulti :itemList="prepareaList"  @select="selectpreparea" />
                
                <smallbutton  @click="go()" toplabel="Save" buttonclass="button buttonsave"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel" buttonclass="button buttoncancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
  import datamethods from '../../services/datamethods.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from '../controls/actionmodal.vue'
import optionbuttonmulti from '../controls/optionbuttonmulti.vue'
export default {
    name:'updateprepareas',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        optionbuttonmulti
    },
    props:{
      
        showButton:{
            type:Boolean,
            default:false
        },


        buttonClass:{
            type:String,
            default:'button buttonprimary bottom10'
        },
        product:{
            type:Object
        }
        
    },
    mixins:[datamethods],
    data(){
        return{
            trueParam:true,
            prepareaList:[]
        }
    },
    computed:{
        ...mapFields([
            'responseMessage',
            'pleaseWait',
            'ticket'

 
        ]),
        name(){
           return 'Select Prep Areas for product ' + this.product.name
        },
       
    },
    methods:{
        
       selectpreparea(id,name){
            this.prepareaList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                let inst=arr[index]
                if(inst.id==id){   
                    inst.selected=!inst.selected
                    inst.dirty=true
                } 
            }
       },
       
        Show(){
            this.getprepareas()
            this.$refs.mymodal.openModal()

        },
        
        async go(){
            let req = {
                  productprepareas:this.prepareaList
              }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateproductproductprepareas')

            if(response.Successful){
                this.$emit('refresh')
                this.$refs.mymodal.closeModal()
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
            
        },
        async getprepareas(){
            let req = {
                  ID:this.product.id
              }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'productprepareas_includeall')

            if(response.Successful){
                this.prepareaList=response.ProductPrepAreaList
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
       
        }
    },
    mounted(){
        
    }
}

</script>

<style>

</style>





























